import { Button, CircularProgress, Typography } from "@mui/material";
import plus from "../Assets/tabler_plus.svg";
import FilterListIcon from "@mui/icons-material/FilterList";
import { Box } from "@mui/system";
import { useState } from "react";
import ButtonComponent from "./buttton";

const FilterBox = ({
  loader,
  name,
  dashboard,
  filterBy,
  fixedData,

  setData,
  options,
  styles,
  imageBool,
  type,
  disabled,
  width,
}) => {
  const [showbox, setShowBox] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");

  const handleSearch = (val, filterProperty) => {
    console.log(val);
    if (!val) {
      setData(fixedData);
      return;
    }
    const filteredRows = fixedData.filter((row) => {
      const propertyValue = String(row[filterProperty]);
      return propertyValue.toLowerCase().includes(val.toLowerCase());
    });

    setData(filteredRows);
  };

  return (
    <div style={{ position: "relative" }}>
      <Button
        type={type || "button"}
        style={{
          border: `1px solid #000`,
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "0.5rem",
          textTransform: "capitalize",
          padding: "7px 16px",
          fontWeight: 500,
          fontSize: "14px",
          color: "#000",
          cursor: "pointer",
          marginRight: "15px",
          height: 30,
        }}
        onClick={() => setShowBox(!showbox)}
        disabled={disabled}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <FilterListIcon />
          <Typography sx={{ color: "#000", marginLeft: "10px" }}>
            Filters
          </Typography>
        </div>
      </Button>
      {showbox ? (
        <Box
          style={{
            width: "300px",
            border: "1px solid #000",
            position: "absolute",
            backgroundColor: "#fff",
            padding: "0 10px",
            zIndex: 1,
            top: "35px",
            ...styles,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: "#000",
              marginLeft: "10px",
              fontSize: "15px",
              fontWeight: "900",
              marginTop: "10px",
            }}
            onClick={() => setShowBox(!showbox)}
          >
            Filters
          </Typography>

          <Box
            style={{
              display: "flex",
              justifyContent: "start",
              alignItems: "start",
              gap: "10px",
              flexDirection: "column",
              marginTop: "10px",
            }}
          >
            {options &&
              options.map((option, index) => (
                <Typography
                  onClick={() => setSelectedOption(option)}
                  key={index}
                  sx={{
                    color: "#000",
                    marginLeft: "10px",
                    marginTop: "10px",
                    cursor: "pointer",
                  }}
                >
                  {option} {selectedOption === option && " ✔"}
                </Typography>
              ))}
          </Box>

          <Box
            style={{
              width: "100%",
              marginTop: "15px",
              height: "1px",
              backgroundColor: "#000",
            }}
          ></Box>
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
              height: "60px",
              alignItems: "center",
            }}
          >
            <Typography
              onClick={() => {
                setShowBox(!showbox);
                setSelectedOption("");
              }}
              sx={{
                color: "#000",
                marginLeft: "10px",
                width: "40%",
                cursor: "pointer",
              }}
            >
              Clear all
            </Typography>
            <Box style={{ width: "40%", marginTop: "20px" }}>
              <ButtonComponent
                loader={false}
                name="Apply"
                // onClick={() => setCategoryIndex(0)}
                onClick={() => {
                  handleSearch(selectedOption, filterBy);
                  setShowBox(!showbox);
                }}
                imageBool={false}
                styles={{
                  marginLeft: "10px",
                  width: "70px",
                  marginTop: "0px",
                  borderRadius: "1px",
                }}
              />
            </Box>
          </Box>
        </Box>
      ) : (
        <></>
      )}
    </div>
  );
};

export default FilterBox;
